import React from 'react';
import { Group, Loader, Select, Text } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import When from '../../common/When';
import { getProductListNothingFoundMessage } from './helpers';
import { requestSurveySelectProps } from './requestSurveyForm';
import { RequestSurveyFormValues, SelectOption } from './types';

type Props = {
    form: UseFormReturnType<RequestSurveyFormValues>;
    activeScopeId: string;
    isZoneScope: boolean;
    listsLoading: boolean;
    productsLoading: boolean;
    productListOptions: SelectOption[];
    selectedProductListId: string;
    productListPlaceholder: string;
    productCount: number;
};

function RequestSurveyProductListField({
    form,
    activeScopeId,
    isZoneScope,
    listsLoading,
    productsLoading,
    productListOptions,
    selectedProductListId,
    productListPlaceholder,
    productCount,
}: Props) {
    return (
        <>
            <Text size="16px" mb={4}>
                Product list
            </Text>
            <Select
                key={`${form.values.scopeKind}-${activeScopeId}-${form.values.surveyType}-${productListOptions.length}`}
                placeholder={productListPlaceholder}
                data={productListOptions}
                disabled={
                    listsLoading ||
                    !activeScopeId ||
                    productListOptions.length === 0
                }
                nothingFoundMessage={getProductListNothingFoundMessage(
                    isZoneScope,
                )}
                {...requestSurveySelectProps}
                {...form.getInputProps('productListId')}
                value={selectedProductListId || null}
                onChange={value => {
                    form.setFieldValue('productListId', value ?? '');
                }}
            />
            <When condition={Boolean(selectedProductListId)}>
                <Group gap={4} mt={4}>
                    <When
                        condition={productsLoading}
                        fallback={
                            <Text size="xs" c="dimmed">
                                {productCount} products found
                            </Text>
                        }
                    >
                        <Loader size="xs" />
                        <Text size="xs" c="dimmed">
                            Loading products...
                        </Text>
                    </When>
                </Group>
            </When>
        </>
    );
}

export default RequestSurveyProductListField;
